import { lazy, Suspense } from 'react';

import { ADD_CONTENT_CHOOSER_ENABLED, UPLOAD_FEATURE_ENABLED } from '../api/vpm/config';
import RequirePermission from '../components/AuthGuards/RequirePermission';
import { PageName } from '../constants/routes.constants';

// /upload routes straight into the incremental wizard (bulk is deferred, so the
// mode chooser adds no value with a single mode). When ADD_CONTENT_CHOOSER_ENABLED
// is turned on (bulk becomes real), /upload renders the AddContent shell instead
// — a one-line restore; both components stay in the codebase.
const Upload = lazy(() =>
  ADD_CONTENT_CHOOSER_ENABLED ? import('../pages/Upload/AddContent') : import('../pages/Upload')
);
const MyUploads = lazy(() => import('../pages/MyUploads'));

// Registered only when the build-time feature flag is on: with
// REACT_APP_ENABLE_UPLOAD unset/false these routes do not exist and the rest
// of the app is byte-for-byte unaffected.
export const UploadRoutes = UPLOAD_FEATURE_ENABLED
  ? [
      // The feature flag decides whether the route EXISTS; the permission
      // decides who may enter it. Both must pass. The guard sits outside
      // Suspense so a denied user never even fetches the page chunk.
      {
        path: PageName.UPLOAD,
        element: (
          <RequirePermission permission="asset.upload">
            <Suspense fallback={<></>}>
              <Upload />
            </Suspense>
          </RequirePermission>
        ),
      },
      {
        path: PageName.MY_UPLOADS,
        element: (
          <RequirePermission permission="asset.upload">
            <Suspense fallback={<></>}>
              <MyUploads />
            </Suspense>
          </RequirePermission>
        ),
      },
    ]
  : [];
